import { z } from 'zod';
import { INVOICE_CONSTRAINTS } from './constraints.js';
import { invoiceIdSchema } from './rules.js';
const REASON_REQUIRED = 'Enter a reason for voiding this invoice.';
export const voidInvoiceInputSchema = z.object({
    invoiceId: invoiceIdSchema,
    reason: z
        .string({ error: REASON_REQUIRED })
        .trim()
        .min(1, REASON_REQUIRED)
        .max(INVOICE_CONSTRAINTS.voidReason.max, `${INVOICE_CONSTRAINTS.voidReason.label} must be ${INVOICE_CONSTRAINTS.voidReason.max.toLocaleString('en-US')} characters or fewer.`),
});
//# sourceMappingURL=void-invoice-input.js.map